/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:59
 */

/**
 * 自定义全局方法
 * */
import Vue from 'vue';
import jsonp from 'jsonp';
import Config from '@/config/index';
import Api from '@/api/index';
import wxShareInfo from '@/public/wxShare'; //初始化wx 每次转跳必须初始化一次

import sc from '@/public/scClass';
import emoji from 'node-emoji';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueScroller from 'vue-scroller';
import Bus from 'vue';
import newWxShare from '@/public/newWxShare'; // 新方法，不兼容之前的share

var VuxLocals = {
  cancel: '取消',
  button_text: '确定',
  confirm_text: '确定',
  cancel_text: '取消',
  week_day_0: '日',
  week_day_1: '一',
  week_day_2: '二',
  week_day_3: '三',
  week_day_4: '四',
  week_day_5: '五',
  week_day_6: '六',
  loading: '加载中',
  'search.placeholder': '搜索',
  back_text: '返回'
};
Vue.use(VueScroller);
Vue.use(VueAwesomeSwiper); // let emoji = require('')
// const aes = require('../assets/js/aes.js')
// const ecb = require('../assets/js/mode-ecb.js')

export default {
  install: function install(Vue, options) {
    Vue.prototype.$t = function (t) {
      return VuxLocals[t] || t;
    };

    Vue.prototype.$getData = function () {};

    Vue.prototype.$jsonp = jsonp;
    Vue.prototype.$config = Config;
    Vue.prototype.$api = new Api();
    Vue.prototype.$wxShareInfo = wxShareInfo;
    Vue.prototype.$wxShare = newWxShare;
    Vue.prototype.$sa = new sc();
    Vue.prototype.$emoji = emoji;
    Vue.prototype.$eventBus = new Bus(); // Vue.prototype.$aes = function aesDecry(data){
    //   var key = CryptoJS.enc.Utf8.parse('YiYangKeJi++++++')
    //   var encryptedHexStr = CryptoJS.enc.Hex.parse(data);
    //   var encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    //   var decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //
    //   return decryptedData.toString(CryptoJS.enc.Utf8);
    // }
  }
};